import React, { useState } from "react";
import "./StartupScreen.css";
import intecLogo from "./components/intecLogo.svg";
import { Terminal } from "./components/Terminal";
import AppRoot from "./AppRoot";

interface StartupScreenProps {
  onReady: () => void;
}

export function StartupScreen({ onReady }: StartupScreenProps) {
  const [showTerminal, setShowTerminal] = useState(false);
  const [showApp, setShowApp] = useState(false);

  // Check if we should show "powered by intecio" button
  // Only show on homepage AND when tenant is "intecio" or not specified
  const urlParams = new URLSearchParams(window.location.search);
  const tenantSlug = urlParams.get('tenant');
  const shouldShowPoweredBy = !showApp && (!tenantSlug || tenantSlug === 'intecio');

  // Handle circle click - show the main app
  const handleCircleClick = () => {
    setShowApp(true);
  };

  // Handle logo click - toggle terminal
  const handleLogoClick = () => {
    setShowTerminal(!showTerminal);
  };

  return (
    <div className="startup-screen">
      <div className={`startup-main-content ${showTerminal ? 'with-terminal' : ''}`}>
        {!showApp ? (
          <>
            <div className="startup-content">
              <div className="blue-dot" onClick={handleCircleClick} title="Go to Dashboard">
                <svg width="100" height="100" viewBox="0 0 24 24" fill="none">
                  <circle cx="12" cy="12" r="10" stroke="#1E88E5" strokeWidth="2.5" fill="none"></circle>
                  <circle cx="12" cy="12" r="6.5" fill="white" opacity="0.7"></circle>
                </svg>
              </div>
            </div>

            {shouldShowPoweredBy && (
              <div className="powered-by" onClick={handleLogoClick} style={{ cursor: 'pointer' }} title={showTerminal ? "Hide Terminal" : "Show Terminal"}>
                <span className="powered-text">Powered by</span>
                <img src={intecLogo} alt="Intec" className="intec-logo" />
              </div>
            )}
          </>
        ) : (
          <div className="startup-app-container">
            {shouldShowPoweredBy && (
              <div className="startup-terminal-toggle" onClick={handleLogoClick} title={showTerminal ? "Hide Terminal" : "Show Terminal"}>
                <span className="powered-text">Powered by</span>
                <img src={intecLogo} alt="Intec" className="intec-logo" />
              </div>
            )}
            <AppRoot />
          </div>
        )}
      </div>

      {showTerminal && (
        <div className="startup-terminal-panel">
          <Terminal onClose={() => setShowTerminal(false)} />
        </div>
      )}
    </div>
  );
}
